module.exports = __webpack_public_path__ + "static/media/junior_tour_step1.53859165.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gJunior/junior_tour_step1.svg
// module id = 327
// module chunks = 21